module.exports = __webpack_public_path__ + "static/media/logo-npr-mark.db837048.svg";